import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { WidgetMapBackground } from './widget-detail/create-map-modal/create-map-modal.component';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Widget, WidgetMap, WidgetMapRegion, WidgetMapType } from '../models/widget';

export interface UpdateMapOptions {
  name: string;
  type: WidgetMapType;
  projectId?: number;

  background: {
    type: WidgetMapBackground;
    sunstudyViewId?: number;
    fileId?: string;
  }
}

@Injectable()
export class WidgetMapService {
  mapTypes: { key: WidgetMapType, name: string }[] = [
    { key: WidgetMapType.Objects, name: 'Objekt' },
    { key: WidgetMapType.Maps, name: 'Kartor' },
    { key: WidgetMapType.Projects, name: 'Projekt' }
  ];

  constructor(private http: HttpClient) {


  }

  updateOrder(widget: Widget, maps: WidgetMap[]) {
    let ids = maps.map((map) => {
      console.log(map.name);
      return map.id;
    });

    let body = JSON.stringify(ids);

    return this.http.post(`${widget.url}/maps-order`, body);
  }

  delete(widgetMap: WidgetMap): Observable<void> {
    return this.http.delete(`${widgetMap.url}`)
      .pipe(map(json => {
        return;
      }));
  }

  replaceImage(widgetMap: WidgetMap, filename: string, name: string): Observable<WidgetMap> {
    let body = JSON.stringify({
      filename: filename,
      name: name
    });

    return this.http.put<any>(`${widgetMap.url}/image`, body)
      .pipe(map(json => new WidgetMap(json)));
  }

  get(widget: Widget): Observable<WidgetMap[]> {
    return this.http.get<any>(`${widget.url}/maps`)
      .pipe(
        map(json => json.data.map((row) => {
          return new WidgetMap(row)
        })));
  }

  find(widget: Widget, id: number): Observable<WidgetMap> {
    return this.http.get(`${widget.url}/maps/${id}`)
      .pipe(map(json => new WidgetMap(json)));
  }

  create(widget: Widget, widgetMap: WidgetMap): Observable<WidgetMap> {
    let body = JSON.stringify(widgetMap.toJson());

    return this.http.post(`${widget.url}/maps`, body)
      .pipe(map(json => new WidgetMap(json)));
  }

  update(widgetMap: WidgetMap): Observable<WidgetMap> {
    let body = JSON.stringify(widgetMap.toJson());

    return this.http.put(`${widgetMap.url}`, body)
      .pipe(map(json => new WidgetMap(json)));
  }

  move(widgetMap: WidgetMap, widget: Widget): Observable<WidgetMap> {
    let body = JSON.stringify({
      widget_id: widget.id
    });

    return this.http.post(`${widgetMap.url}/move`, body)
      .pipe(map(json => new WidgetMap(json)));
  }

  updateRegion(region: WidgetMapRegion): Observable<WidgetMapRegion> {
    const body = JSON.stringify(region.toJson());

    return this.http.put(`${region.url}`, body)
      .pipe(map(json => new WidgetMapRegion(json)));
  }

  updateRegions(widgetMap: WidgetMap, regions: WidgetMapRegion[]) {
    let body = JSON.stringify({
      regions: regions.map(r => {
        return r.toJson();
      })
    });

    return this.http.put(`${widgetMap.url}/regions?batch`, body)
      .pipe(map(json => new WidgetMap(json)));
  }

  addRegion(widgetMap: WidgetMap, region: WidgetMapRegion): Observable<WidgetMapRegion> {
    return this.http.post<any>(`${widgetMap.url}/regions`, region.toJson())
      .pipe(map(json => new WidgetMapRegion(json)));
  }

  processImages(map: WidgetMap) {
    return this.http.post<void>(`${map.url}/processimages`, '');
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-map.service.ts